export const vyora = {
  navy: '#14213D',
  navyMid: '#1C2B4B',
  deepBlue: '#3159A6',
  teal: '#00B894',
  tealDark: '#008F78',
  aqua: '#00B894',
  purple: '#6366F1',
  ink: '#14213D',
  muted: '#4F5F78',
  canvas: '#F5F7FC',
  paper: '#FFFFFF',
  border: '#E2E7EF',
  danger: '#E53935',
  dangerBg: '#FFF0F0',
  warning: '#E59A00',
  info: '#3159A6',
  success: '#0B9F73',
  hairlineLight: '#E2E7EF',
  hairlineDark: 'rgba(148, 163, 184, 0.14)',
} as const;

export const FONT_FAMILY =
  '"Poppins", "Noto Sans Devanagari", "Noto Sans Telugu", "Noto Sans Bengali", "Noto Sans Oriya", "Noto Sans Gujarati", "Noto Sans Arabic", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif';

